(() => {
  const config = globalThis.StorefrontLocaleConfig || {};
  const language = config.language;
  const root = language === 'en' ? '/en/' : language === 'de' ? '/' : config.root || '/';
  const aliases = config.aliases || {};
  function url(value, nested = false) {
    if (typeof value !== 'string' || !value || /^[#?]|^(mailto|tel|javascript|data):/i.test(value)) return value;
    let destination = value;
    if (/^(https?:)?\/\//i.test(destination)) {
      let parsed;
      try { parsed = new URL(destination, globalThis.location?.origin || 'https://deinfriseur.de'); } catch { return value; }
      const allowed = ['deinfriseur.de', 'www.deinfriseur.de'];
      if (!allowed.includes(parsed.hostname) && parsed.origin !== globalThis.location?.origin) return value;
      if (parsed.username || parsed.password) return value;
      destination = parsed.pathname + parsed.search + parsed.hash;
    }
    const match = /^(\/[^?#]*)([\s\S]*)$/.exec(destination);
    if (!match || destination.startsWith('//') || !['de', 'en'].includes(language)) return destination;
    let path = match[1].replace(/^\/en(?=\/|$)/, '') || '/';
    if (!/^\/(products|collections|pages|blogs|policies|search|cart|discount|recommendations)(\/|\.|$)/.test(path) && path !== '/') return destination;
    for (const [prefix, translations] of Object.entries(aliases)) {
      if (path === prefix || path.startsWith(prefix + '/')) {
        path = translations[language] + path.slice(prefix.length);
        break;
      }
    }
    let result = (language === 'en' ? '/en' : '') + path + match[2];
    if (!nested && /^\/(?:en\/)?discount\//.test(result)) {
      result = result.replace(/([?&](?:amp;)?redirect=)([^&#]*)/, (all, key, encoded) => {
        try { return key + encodeURIComponent(url(decodeURIComponent(encoded.replace(/\+/g, ' ')), true)); } catch { return all; }
      });
    }
    return result;
  }
  globalThis.StorefrontLocale = Object.freeze({ language, root, url });
})();
